import styled, { css } from 'styled-components'

import {
    AbsolutePositioning,
    FlexCentered,
} from 'components/common/genericStyles'
import { Color } from 'constants/color'

export const MobileStudentWrapper = styled.div`
    position: relative;
    border-radius: 50%;
    width: 100%;
    height: 100%;
`

export const MobileStudentAvatarWrapper = styled.div`
    ${props =>
        props.visible
            ? css`
                  display: block;
              `
            : css`
                  display: none;
              `}
`

export const MobileTeacherWrapper = styled.div`
    position: relative;
    width: 100%;

    @media only screen and (orientation: landscape) {
        height: 100%;
    }
`

export const AvatarWrapper = styled.div`
    ${AbsolutePositioning};
    padding: 6px;
    z-index: -1;
    border-radius: 50%;
`

export const VideoWrapper = styled(AvatarWrapper)`
    padding: 5px;
`

export const ReactionWrapperBase = styled.div`
    ${FlexCentered};
    position: absolute;
    top: 4px;
    bottom: 4px;
    left: 4px;
    right: 4px;
    overflow: hidden;

    ${props =>
        props.isGiphy &&
        css`
            background: ${Color.unknownColor19};
        `}
`
